module.exports = __webpack_public_path__ + "img/win_night.74410e98.png";